import angular from 'angular';
import gettext from 'angular-gettext';
import deleteElementDialog from '../../../cmsCore/DeleteElementModal/deleteElement';

/**
 * @memberOf cms.input.columns
 * @property {object}      bindings.errors     Form errors object
 * @property {object|text} bindings.model      Input value reference
 * @property {object|text} bindings.options    Options to select
 * @property {string}      bindings.title      Input title and/or placeholder
 * @property {string}      bindings.labelSize  Label column size (1-12)
 * @property {string}      bindings.inputSize  Input column size (1-12)
 * @property {string}      bindings.aclShow    ACL config - show input
 * @property {string}      bindings.aclDisable ACL config - disable input
 *
 */
let cmsInputColumns = {
    bindings: {
        errors: '<',
        model: '=',
        options: '<',
        label: '@',
        helper: '@',
        labelSize: '@',
        inputSize: '@',
        aclShow: '<?',
        aclDisable: '<?'
    },
    template: require('./columns.html'),
    controller: function (deleteElementDialog, gettext, $scope) {

        this.$onInit = () => {
            /* TODO: Sprawdzić, czy $onInit jest wciąż potrzebne, gdy przypisanie klucza mamy w WorkspaceElement */
            if(!this.model.hasOwnProperty('columnsWidth')) {
                this.model.columnsWidth = [];
                angular.forEach(this.model.children, (value, key) => {
                    this.model.columnsWidth[key] =  (12 / this.model.children.length);
                });
            }
        };


        let rebuildColumns = (newColumnsCount) => {

            if (this.model.children.length === newColumnsCount) {
                return;
            }

            if (this.model.children.length < newColumnsCount) {
                while (this.model.children.length < newColumnsCount) {
                    this.model.children.push([]);
                    this.model.columnsWidth = addElementToWidths(this.model.columnsWidth);
                }
            } else {
                while (this.model.children.length > newColumnsCount) {
                    this.model.children.pop();
                    this.model.columnsWidth = removeElementFromWidths(this.model.columnsWidth)
                }
            }

        };

        /**
         * Return columns widths when new element added
         * @param columnsWidths {array}
         * @returns {array}
         */
        let addElementToWidths = (columnsWidths) => {

            if(!getColumnChildrenCount()) {
                return getEqualColumnsWidth();
            }

            let gainedSpace = 0;
            let newColumnsWidths = [...columnsWidths].reverse().map((oldWidth) =>{
                if(oldWidth>1 && !gainedSpace) {
                    gainedSpace = gainedSpace+1;
                    return --oldWidth;
                }
                return oldWidth;
            });

            newColumnsWidths.reverse();
            newColumnsWidths.push(gainedSpace);

            return newColumnsWidths;

        };

        /**
         * Return column widths when element removed
         * @param columnsWidths
         */
        let removeElementFromWidths = (columnsWidths) => {

            if(!getColumnChildrenCount()) {
                return getEqualColumnsWidth();
            }

            let newColumnsWidths = [...columnsWidths];
            let removedWidth = newColumnsWidths.pop();
            newColumnsWidths[newColumnsWidths.length-1] += removedWidth;
            return newColumnsWidths;
        };

        /**
         * Return count of children elements in columns
         * @returns {integer}
         */
        let getColumnChildrenCount = () => {
            return this.model.children.reduce((acc,column)=> acc+column.length, 0);
        };

        /**
         * Get optimal columns width
         * @returns {number[]}
         */
        let getEqualColumnsWidth = () => {
            return Array(this.model.children.length).fill(null).map(() => 12/this.model.children.length);
        };

        this.selectOption = (newCount) => {
            let oldCount =  this.model.children.length;
            if (newCount < oldCount && removedColumnsNotEmpty(newCount, oldCount)) {
                let deleteMessage = gettext("Do you really want to change number of columns? Content of last columns will be removed. (This action is irreversible!)");
                return deleteElementDialog.open(deleteMessage).then(() => {
                    rebuildColumns(newCount)
                }).catch(() => {
                });
            } else {
                rebuildColumns(newCount);
            }

            $scope.$emit('content-changed');
        };

        let removedColumnsNotEmpty = (newCount, oldCount) => {
            for(let i = oldCount; i > newCount; i--) {
                if(this.model.children[i-1].length) {
                    return true;
                }
            }
            return false;
        };
    }

};

export default angular.module('cms.input.columns', [deleteElementDialog, gettext])
    .component('cmsInputColumns', cmsInputColumns)
    .name;




// WEBPACK FOOTER //
// ./src/cmsCore/Controls/ColumnsControl/CmsInputColumns.js